import React, { Component } from 'react';
import { compose } from 'recompose';
import withAuthorization from '../Session/withAuthorization';
import firebase from 'firebase';
import Spinner from '../Spinner';
const moment = require('moment');


class VendorHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historyData: []
    }
    this.renderHistory = this.renderHistory.bind(this)
  }

  componentDidMount() {
    var self = this;
    firebase.database().ref('vendorHistory').on('value', function (snap) {
      var temp = snap.val()
      self.setState({
        historyData: temp
      })
    })
  }

  renderHistory(temp) {
    var res = temp.created ? temp.created : temp.updated
    console.log(res)
    if (res) {
      return (
        <ul>
          Updated -
          {
            Object.keys(res).map(key => {
              return (<li>{key}</li>)
            })
          }
        </ul>
      )

    }
  }

  getTime(time) {
    var d = moment.unix(time).format("'MMMM Do YYYY, h:mm:ss a'");
    return (d)
  }
  render() {
    var temp = this.state.historyData, self = this
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column' }} className="display_home">
        {console.log(temp)}
        {Object.keys(temp).length > 0 ?
          Object.keys(temp).map(key => {
            let te = temp[key]
            return (
              <span className="limiter" style={{ justifyContent: 'flex-start', textAlign: 'left' }}>
                {
                  Object.keys(te).map(k => {
                    return (
                      <span>
                        {
                          te[k].createdBy ?
                            <span>Created User by {te[k].createdBy} at {self.getTime(te[k].timestamp)}</span> :
                            <span>Updated User by {te[k].updatedBy} at {self.getTime(te[k].timestamp)}</span>}
                        {this.renderHistory(te[k])
                        }
                        <hr />
                      </span>
                    )
                  })
                }
                <br />
              </span>
            )
          }) : <Spinner />
        }
      </div>
    )
  }
}
const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition)
)(VendorHistory);